/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : Oauth-API.ts
 *
 * Project Title : RDR7000
 *
 * Description   : Contains oAuth related functions.
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Amol Jagtap (H409453)
 *
 * @Date         : Aug 12, 2020
 *
 * @Version      : Version 1.0
 *
 * By            : Amol Jagtap (H409453)
 * On            : Aug 12, 2020
 * Description   : Add 'getToken' function to get Auth Token
 *
 *
 ******************************************************************************/

import axios from 'axios';
import { IUserRoleState } from 'models/auth';
import { appConfig } from 'shared/utils';

export const getUserRoleAPI = async(
): Promise<IUserRoleState> => {
  const { api_endpoint } = appConfig;
  const { data } = await axios.get<IUserRoleState>(api_endpoint+'/user-role', {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });

  return data;
};
